import type { ReactNode } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

export type StateTemplateProps = {
  title: string;
  subTitle?: ReactNode;
  icon: ReactNode;
  children?: ReactNode;
};

export const StateTemplate = ({ title, subTitle, icon, children }: StateTemplateProps) => {
  return (
    <Flex justifyContent="center">
      <Flex className={styles.container} alignItems="center" flexDirection="column">
        {icon}
        <Text className={styles.title} variant="h3">
          {title}
        </Text>
        {subTitle && (
          <Text className={styles.subTitle} variant="secondary-md">
            {subTitle}
          </Text>
        )}
        {children && (
          <Flex className={styles.actions} alignItems="center" gap={SPACING.SMALL}>
            {children}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
